import {
  fireProtectionRatingTypesService,
  type FireProtectionRatingType,
} from '@/services/fire-protection-rating-types';
import { useQuery } from '@tanstack/react-query';

type UseFireProtectionRatingTypesParams = {
  enabled?: boolean;
};

export function useFireProtectionRatingTypes({
  enabled = true,
}: UseFireProtectionRatingTypesParams = {}) {
  return useQuery<FireProtectionRatingType[], Error>({
    queryKey: ['fire-protection-rating-types'],
    queryFn: async () => {
      const response =
        await fireProtectionRatingTypesService.getFireProtectionRatingTypes();

      if (!response.success || !response.data) {
        throw new Error(
          response.error ||
            'Erro ao carregar sistemas de proteção contra incêndio'
        );
      }

      return response.data.data;
    },
    enabled,
    staleTime: 5 * 60 * 1000,
  });
}
